import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";

export interface Opcional {
  id: number;
  descricao?: string;
  quantidadeMaxima: number;
}

export interface OpcionalFormData {
  descricao?: string;
  quantidadeMaxima?: number;
}

export function useOpcionais() {
  const queryClient = useQueryClient();

  const { data: opcionais = [], isLoading } = useQuery({
    queryKey: ["opcionais"],
    queryFn: async () => {
      const { data } = await apiClient.get<Opcional[]>("/api/opcionais");
      return data;
    },
  });

  const createOpcional = useMutation({
    mutationFn: async (formData: OpcionalFormData) => {
      const { data } = await apiClient.post<Opcional>("/api/opcionais", formData);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["opcionais"] });
      toast.success("Opcional criado com sucesso!");
    },
    onError: (error: Error) => {
      toast.error("Erro ao criar opcional: " + error.message);
    },
  });

  const updateOpcional = useMutation({
    mutationFn: async ({ id, ...formData }: OpcionalFormData & { id: number }) => {
      const { data } = await apiClient.put<Opcional>(`/api/opcionais/${id}`, formData);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["opcionais"] });
      toast.success("Opcional atualizado com sucesso!");
    },
    onError: (error: Error) => {
      toast.error("Erro ao atualizar opcional: " + error.message);
    },
  });

  const deleteOpcional = useMutation({
    mutationFn: async (id: number) => {
      await apiClient.delete(`/api/opcionais/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["opcionais"] });
      toast.success("Opcional excluído com sucesso!");
    },
    onError: (error: Error) => {
      toast.error("Erro ao excluir opcional: " + error.message);
    },
  });

  return {
    opcionais,
    isLoading,
    createOpcional,
    updateOpcional,
    deleteOpcional,
  };
}
